import { render, staticRenderFns } from "./TableVagaIntegral.vue?vue&type=template&id=7d0bab97"
import script from "./TableVagaIntegral.vue?vue&type=script&lang=js"
export * from "./TableVagaIntegral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports